module.exports = __webpack_public_path__ + "img/vip-bar-img.9fc3cc6d.png";